<template>
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M8 .5a.75.75 0 0 1 .75.75v7.19l2.47-2.47a.75.75 0 1 1 1.06 1.06l-3.75 3.75a.75.75 0 0 1-1.06 0L3.72 7.03a.75.75 0 0 1 1.06-1.06l2.47 2.47V1.25A.75.75 0 0 1 8 .5Zm-6.75 9a.75.75 0 0 1 .75.75v3a.75.75 0 0 0 .75.75h10.5a.75.75 0 0 0 .75-.75v-3a.75.75 0 0 1 1.5 0v3a2.25 2.25 0 0 1-2.25 2.25H2.75A2.25 2.25 0 0 1 .5 13.25v-3a.75.75 0 0 1 .75-.75Z"
      fill="currentColor"
    />
  </svg>
</template>
